import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';

const FINAL_RECAP_VIMEO_ID = '1186629236';
const VIDEO_THUMB_URL = `https://vumbnail.com/${FINAL_RECAP_VIMEO_ID}.jpg`;

const VideoThumb = () => (
  <div className="lp-thumb">
    <img src={VIDEO_THUMB_URL} alt="Final party recap" loading="eager" />
    <div className="lp-thumb-overlay" />
    <div className="lp-play" aria-hidden="true">▶</div>
  </div>
);

const MarketThumb = () => (
  <div className="lp-thumb lp-thumb-market">
    <div className="lp-chart-grid" />
    <svg className="lp-chart-line" viewBox="0 0 220 200" preserveAspectRatio="none">
      <defs>
        <linearGradient id="lp-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00ff00" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#00ff00" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M0,140 L20,120 L40,150 L60,90 L80,110 L100,70 L120,95 L140,55 L160,80 L180,40 L200,60 L220,30 L220,200 L0,200 Z"
        fill="url(#lp-fill)"
      />
      <path
        d="M0,140 L20,120 L40,150 L60,90 L80,110 L100,70 L120,95 L140,55 L160,80 L180,40 L200,60 L220,30"
        fill="none"
        stroke="#00ff00"
        strokeWidth="2"
        style={{ filter: 'drop-shadow(0 0 4px #00ff00)' }}
      />
    </svg>
    <div className="lp-tickers">
      <span className="lp-up">KMOK +12.4%</span>
      <span className="lp-down">SHRT -3.1%</span>
    </div>
  </div>
);

const InviteThumb = () => (
  <div className="lp-thumb lp-thumb-invite">
    <div className="lp-prompt">&gt; KOMOK//STOCK TERMINAL</div>
    <div className="lp-prompt">&gt; INCOMING TRANSMISSION...</div>
    <div style={{ marginTop: '6px' }}>YOU ARE INVITED</div>
    <div>03/20/2026 — 18:45</div>
    <div>VANCOUVER, BC</div>
    <div style={{ marginTop: '6px', opacity: 0.85 }}>
      RSVP<span className="lp-cursor" />
    </div>
  </div>
);

const MusicThumb = () => (
  <div
    className="lp-thumb lp-thumb-music"
    style={{
      background: '#000',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '10px 12px',
      color: '#00ff41',
      fontFamily: "'Courier New', monospace",
      letterSpacing: '2px',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <div style={{ fontSize: '0.7rem', opacity: 0.7, display: 'flex', justifyContent: 'space-between' }}>
      <span>KOMOK//FM</span>
      <span style={{ color: '#00ff41' }}>● LIVE</span>
    </div>
    <div style={{ fontSize: '0.85rem', textAlign: 'center', textShadow: '0 0 8px #00ff41', fontWeight: 'bold' }}>
      ▶ NOW PLAYING
    </div>
    <div
      style={{
        height: '20px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        gap: '3px',
      }}
    >
      {[0.6, 0.85, 0.45, 0.95, 0.7, 0.55, 0.9, 0.5, 0.75, 0.65, 0.4, 0.85].map((h, i) => (
        <div
          key={i}
          style={{
            width: '4px',
            height: `${h * 100}%`,
            background: '#00ff41',
            boxShadow: '0 0 4px #00ff41',
            animation: `lp-eq 0.8s ${i * 0.07}s infinite alternate ease-in-out`,
          }}
        />
      ))}
    </div>
    <div style={{ fontSize: '0.65rem', opacity: 0.6, textAlign: 'center' }}>
      26 KOMOK TRACKS
    </div>
    <style>{`@keyframes lp-eq { from { transform: scaleY(0.4); } to { transform: scaleY(1); } }`}</style>
  </div>
);

const CalendarThumb = () => (
  <div
    className="lp-thumb lp-thumb-calendar"
    style={{
      background: '#050a05',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '8px 10px',
      color: '#00ff41',
      fontFamily: "'Courier New', monospace",
      letterSpacing: '1px',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <div style={{ fontSize: '0.6rem', opacity: 0.7, display: 'flex', justifyContent: 'space-between' }}>
      <span>UPCOMING</span>
      <span>● LIVE</span>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '0.62rem' }}>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <span style={{ background: 'rgba(0,255,65,0.2)', padding: '1px 4px', minWidth: '24px', textAlign: 'center', fontWeight: 'bold' }}>26</span>
        <span style={{ opacity: 0.85, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>WORKSHOP OPEN</span>
      </div>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <span style={{ background: 'rgba(76,201,255,0.2)', color: '#4cc9ff', padding: '1px 4px', minWidth: '24px', textAlign: 'center', fontWeight: 'bold' }}>02</span>
        <span style={{ opacity: 0.85, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>R32 HASTINGS</span>
      </div>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <span style={{ background: 'rgba(255,110,199,0.2)', color: '#ff6ec7', padding: '1px 4px', minWidth: '24px', textAlign: 'center', fontWeight: 'bold' }}>26</span>
        <span style={{ opacity: 0.85, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>NELLY @ PNE</span>
      </div>
    </div>
    <div style={{ fontSize: '0.55rem', opacity: 0.55, textAlign: 'center', letterSpacing: '1.5px' }}>
      KOMOK · KOOK · CONCERTS
    </div>
  </div>
);

const WorkshopThumb = () => (
  <div
    className="lp-thumb lp-thumb-workshop"
    style={{
      background: '#050a05',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '10px 12px',
      color: '#00ff41',
      fontFamily: "'Courier New', monospace",
      letterSpacing: '2px',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <div style={{ fontSize: '0.65rem', opacity: 0.7, display: 'flex', justifyContent: 'space-between' }}>
      <span>KOMOK//SHOP</span>
      <span>● OPEN</span>
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '3px', textAlign: 'center', fontSize: '0.85rem', lineHeight: '1' }}>
      <span>🪚</span><span>🔥</span><span>🧊</span><span>🏷️</span>
      <span>⚡</span><span>📡</span><span>🎬</span><span>📷</span>
    </div>
    <div style={{ fontSize: '0.62rem', opacity: 0.6, textAlign: 'center' }}>
      34 TOOLS · BOOK A SLOT
    </div>
  </div>
);

const KookThumb = () => (
  <div
    className="lp-thumb lp-thumb-kook"
    style={{
      background: 'radial-gradient(ellipse at 30% 50%, rgba(76,201,255,0.35) 0%, transparent 65%), radial-gradient(ellipse at 70% 50%, rgba(255,58,92,0.35) 0%, transparent 65%), #0a0a0a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '6px',
      color: '#f5c518',
      fontWeight: 800,
      letterSpacing: '0.18em',
    }}
  >
    <div style={{ fontSize: '0.7rem', opacity: 0.7 }}>KASNER ✕ RAKSO</div>
    <div style={{ fontSize: '1.4rem' }}>KOOK</div>
    <div style={{ fontSize: '0.85rem', letterSpacing: '0.32em' }}>OLYMPICS</div>
    <div style={{ display: 'flex', gap: '8px', marginTop: '6px', fontSize: '0.7rem', opacity: 0.85 }}>
      <span style={{ color: '#ff3a5c' }}>54</span>
      <span style={{ color: '#888' }}>—</span>
      <span style={{ color: '#4cc9ff' }}>52</span>
    </div>
  </div>
);

const OPTIONS = [
  {
    key: 'video',
    label: "KOMOK'S STOCK MARKET PARTY VIDEO",
    subtitle: 'Watch the video for the party and see what happened, who won, and how it all went down! (Click here to watch!)',
    href: '/videos/?tab=party-video',
    Thumb: VideoThumb,
    isNew: true,
  },
  {
    key: 'market',
    label: 'MARKET TERMINAL',
    subtitle: 'Live trading floor — stocks, portfolios, leaderboard. See how the app worked and the stocks, players, and leaderboard.',
    href: '/market',
    Thumb: MarketThumb,
  },
  {
    key: 'invite',
    label: 'THE INVITATION',
    subtitle: 'Checkout the original terminal invite, the hype, the past parties, and more fun stuff!',
    href: '/invite',
    Thumb: InviteThumb,
  },
  {
    key: 'music',
    label: 'KOMOK//FM MUSIC',
    subtitle: 'The official KOMOK party soundtrack — 26 tracks from the trading floor. Stream the full archive in the terminal player.',
    href: '/videos?section=music',
    Thumb: MusicThumb,
  },
  {
    key: 'workshop',
    label: 'KOMOK//WORKSHOP',
    subtitle: 'Hackerspace open for builds. Power tools, lasers, 3D printers, label printers, electronics bench. Book a tool, bring your parts, make stuff.',
    href: '/workshop',
    Thumb: WorkshopThumb,
  },
  {
    key: 'kook',
    label: 'KOOK OLYMPICS',
    subtitle: 'Kasner vs Rakso — who is the better twin? Every event, every year, dating back to childhood. Currently 54–52.',
    href: 'https://kook.gg',
    Thumb: KookThumb,
  },
  {
    key: 'calendar',
    label: 'KOMOK//CALENDAR',
    subtitle: 'Upcoming hangs, watch parties, concerts and trips. Workshop opens May 26. Round of 32 at Hastings July 2.',
    href: '/calendar',
    Thumb: CalendarThumb,
  },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const go = (href) => {
    if (href.startsWith('/')) navigate(href);
    else window.location.href = href;
  };

  const timestamp = now.toISOString().replace('T', ' ').slice(0, 19) + ' UTC';

  return (
    <div className="lp-root">
      <div className="lp-topbar">
        <span>KOMOK//STOCK ▮ TERMINAL</span>
        <span>{timestamp}</span>
      </div>

      <div className="lp-header">
        <div className="lp-title">KOMOK STOCK PARTY</div>
        <div className="lp-subtitle">&gt; SELECT A BOX TO GO TO THE NEXT PAGE</div>
      </div>

      <div className="lp-cards">
        {OPTIONS.map((opt, idx) => {
          const { Thumb } = opt;
          return (
            <button
              key={opt.key}
              className="lp-card"
              onClick={() => go(opt.href)}
            >
              <Thumb />
              <div className="lp-card-body">
                <div className="lp-card-label">
                  <span className="lp-card-label-text">
                    [{String(idx + 1).padStart(2, '0')}] {opt.label}
                  </span>
                  {opt.isNew && <span className="lp-new-badge">NEW</span>}
                </div>
                <div className="lp-card-sub">{opt.subtitle}</div>
              </div>
              <div className="lp-card-arrow" aria-hidden="true">&gt;</div>
            </button>
          );
        })}
      </div>

      <div className="lp-footer">
        <span className="lp-footer-bracket">▮</span>
        {OPTIONS.map((opt, idx) => (
          <React.Fragment key={opt.key}>
            <button
              type="button"
              className="lp-footer-link"
              onClick={() => go(opt.href)}
            >
              [{String(idx + 1).padStart(2, '0')}] {opt.label}
            </button>
            {idx < OPTIONS.length - 1 && <span className="lp-footer-sep">|</span>}
          </React.Fragment>
        ))}
        <span className="lp-footer-bracket">▮</span>
      </div>
    </div>
  );
};

export default LandingPage;
